import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'smr-calendar-settings',
  templateUrl: './calendar-settings.component.html',
  styleUrls: ['./calendar-settings.component.scss'],
})
export class CalendarSettingsComponent  implements OnInit {

  dayNumbers: Array<number> = [1,2,3,4,5,6,7];
  daysToDisplay: number = 1 ;

  constructor (private popoverCtrl: PopoverController) {
  }

  ngOnInit() {
      this.daysToDisplay = parseInt(localStorage.getItem('daysToDisplay'));
  }

  onSetDaysToDisplay(day:number) {
    localStorage.setItem('daysToDisplay', day.toString());
    this.daysToDisplay = day;
    this.popoverCtrl.dismiss({daysToDisplay: day});
  }

}
